module.exports = __webpack_public_path__ + "img/WE_banner.5c3f9e87.png";